export enum PerformanceCategoriesSupport {
  None,
  Summary,
  Collecting
}
